import React, { useState, useEffect } from 'react'
import { Col, Row, Button, Modal } from 'reactstrap';
import { HeaderModal, DateForm } from "../Basicos/index"
import { parseDate, formatDate, formatLaravelDate, formatoData } from '../Basicos/funcoes'

const dataFormStyle = {
    style: {
        labelClass: "label-conteudoInferior",
        elementoClass: "",
        col: { xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }
    }
}

const formatarDataExibicao = (data) => {
    const dataFormatada = formatDate(parseDate(data, formatLaravelDate), formatoData);
    return dataFormatada || '-';
};

const ModalReaproveitarSemanaPadrao = ({
    isOpen,
    setIsOpen,
    temaOrigemNome,
    temaOrigemDataInicio,
    temaOrigemDataFim,
    sugestaoDataInicio,
    sugestaoDataFim,
    onConfirmar,
    onCancelar
}) => {
    const [intervalo, setIntervalo] = useState({});
    const [erro, setErro] = useState(null);
    const [salvando, setSalvando] = useState(false);

    useEffect(() => {
        if (isOpen) {
            setIntervalo({ from: sugestaoDataInicio, to: sugestaoDataFim });
            setErro(null);
        }
    }, [isOpen, sugestaoDataInicio, sugestaoDataFim]);

    const fechar = () => {
        setIsOpen(false);
        setIntervalo({});
        setErro(null);
        if (onCancelar) onCancelar();
    };

    const confirmar = async () => {
        if (!intervalo.from || !intervalo.to) return;

        if (temaOrigemDataFim && intervalo.from <= temaOrigemDataFim) {
            setErro(`A Data Inicial deve ser posterior à Data Final do ${temaOrigemNome} (${formatarDataExibicao(temaOrigemDataFim)}).`);
            return;
        }

        setErro(null);
        setSalvando(true);
        try {
            await onConfirmar(intervalo.from, intervalo.to);
            setIsOpen(false);
            setIntervalo({});
        } catch (error) {
            setErro(error.response?.data?.erro || "Não foi possível reaproveitar a configuração.");
        } finally {
            setSalvando(false);
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            toggle={fechar}
            size={'md'}
            centered={true}
            className={"modal-map-body"}
            backdrop="static"
        >
            <Row noGutters={true}>
                <HeaderModal sm={12} toggle={fechar} titulo={"REAPROVEITAR CONFIGURAÇÃO"} />
                <Col sm={12} style={{ fontSize: '0.9rem', padding: '15px 25px 0', color: 'var(--cor-text-secundario)', textAlign: 'left', whiteSpace: 'pre-line' }}>
                    {`Já existe uma configuração cadastrada no ${temaOrigemNome}. Deseja reaproveitá-la para este tema?`}
                </Col>
                <Col sm={12} style={{ fontSize: '0.85rem', padding: '8px 25px', color: 'var(--cor-text-secundario)', textAlign: 'left' }}>
                    <strong>Período do {temaOrigemNome}:</strong> {formatarDataExibicao(temaOrigemDataInicio)} a {formatarDataExibicao(temaOrigemDataFim)}
                </Col>
                <Col sm={12} style={{ fontSize: '0.9rem', padding: '0 25px 10px', color: 'var(--cor-text-secundario)', textAlign: 'left' }}>
                    Informe a Data Inicial e a Data Final deste tema para aplicar aos horários copiados:
                </Col>
                <Col sm={12} style={{ padding: '8px 15px' }}>
                    <Row>
                        <DateForm
                            name="intervalo_reaproveitar"
                            label="Período do Tema"
                            style={{ labelClass: "label-centralizado" }}
                            onChange={(name, value) => {
                                setIntervalo(prev => ({
                                    from: value.from ?? prev.from,
                                    to: value.to ?? value.toFormated ?? prev.to
                                }));
                                setErro(null);
                            }}
                            dataInicial={{ label: "Data Inicial", placeholder: "Data Inicial", diasFuturos: true, ...dataFormStyle }}
                            dataFinal={{ label: "Data Final", placeholder: "Data Final", diasFuturos: true, ...dataFormStyle }}
                            value={{ from: parseDate(intervalo.from, formatLaravelDate), to: parseDate(intervalo.to, formatLaravelDate) }}
                        />
                    </Row>
                </Col>
                {erro &&
                    <Col sm={12} style={{ fontSize: '0.85rem', padding: '0 15px 10px', color: 'var(--cor-button-danger)', textAlign: 'left' }}>
                        {erro}
                    </Col>
                }
                <Col sm={12} className="modal-reaproveitar__acoes" style={{ padding: '8px 15px' }}>
                    <Row>
                        <Col xs={6}>
                            <Button block disabled={salvando} onClick={fechar} className="modal-reaproveitar__btn-cancelar m-0">
                                NÃO REAPROVEITAR
                            </Button>
                        </Col>
                        <Col xs={6}>
                            <Button block disabled={!intervalo.from || !intervalo.to || salvando} onClick={confirmar} className="modal-reaproveitar__btn-confirmar m-0">
                                {salvando ? "SALVANDO..." : "CONFIRMAR"}
                            </Button>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <style>{`
                .modal-reaproveitar__acoes .modal-reaproveitar__btn-confirmar {
                    float: none !important;
                    background-image: none !important;
                    background-color: var(--cor-principal) !important;
                    border-color: var(--cor-principal) !important;
                    color: #fff !important;
                }
                .modal-reaproveitar__acoes .modal-reaproveitar__btn-confirmar:disabled {
                    opacity: 0.5 !important;
                }
                .modal-reaproveitar__acoes .modal-reaproveitar__btn-cancelar {
                    float: none !important;
                    background-image: none !important;
                    background-color: #fff !important;
                    border-color: var(--cor-button-danger) !important;
                    color: var(--cor-button-danger) !important;
                }
                .modal-reaproveitar__acoes .modal-reaproveitar__btn-cancelar:disabled {
                    opacity: 0.5 !important;
                }
            `}</style>
        </Modal>
    );
}

export default ModalReaproveitarSemanaPadrao;
